import { createFileRoute } from "@tanstack/react-router";
import { faqPageScript, i18nLinks, i18nOgMeta, localeUrl } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import { YoutubeThumbnailIndex } from "@/tools/youtube-thumbnail/pages/YoutubeThumbnailIndex";

const PATH = "/youtube-thumbnail-downloader";

export const Route = createFileRoute("/youtube-thumbnail-downloader/")({
  ssr: true,
  head: () => ({
    meta: [
      { title: m.yt_hub_meta_title() },
      { name: "description", content: m.yt_hub_meta_description() },
      { property: "og:title", content: m.yt_hub_meta_title() },
      { property: "og:description", content: m.yt_hub_meta_description() },
      ...i18nOgMeta(PATH),
    ],
    links: [...i18nLinks(PATH)],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: m.yt_breadcrumb_home(),
              item: localeUrl(`/`),
            },
            {
              "@type": "ListItem",
              position: 2,
              name: m.yt_tool_name(),
              item: localeUrl(`${PATH}`),
            },
          ],
        }),
      },
      faqPageScript([
        { q: m.yt_hub_faq1_q(), a: m.yt_hub_faq1_a() },
        { q: m.yt_hub_faq2_q(), a: m.yt_hub_faq2_a() },
        { q: m.yt_hub_faq3_q(), a: m.yt_hub_faq3_a() },
        { q: m.yt_hub_faq4_q(), a: m.yt_hub_faq4_a() },
      ]),
    ],
  }),
  component: YoutubeThumbnailIndex,
});
